import { render } from "./ProspectAiWidget.vue?vue&type=template&id=0e5f8e02"
import script from "./ProspectAiWidget.vue?vue&type=script&lang=js"
export * from "./ProspectAiWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__